import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/home' },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/adresses',
    name: 'Adresses',
    component: function () {
      return import('../views/Adresses.vue')
    }
  },
  {
    path: '/please-comment',
    name: 'Comments',
    component: function () {
      return import('../views/Comments.vue')
    }
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: function () {
      return import('../views/Faqs.vue')
    }
  },
  {
    path: '/srimad-bhagavatam',
    name: 'SrimadBhagavatam',
    component: function () {
      return import('../views/SrimadBhagavatam.vue')
    }
  },
  {
    path: '/ramayana',
    name: 'Ramayana',
    component: function () {
      return import('../views/Ramayana.vue')
    }
  },
  {
    path: '/bg-40',
    name: 'BhagavadG40',
    component: function () {
      return import('../views/BhagavadG40.vue')
    }
  },
  {
    path: '/shiva',
    name: 'Shiva',
    component: function () {
      return import('../views/threeD/LordShiva.vue')
    }
  },
  {
    path: '/lord-ganesh',
    name: 'LordGanesh',
    component: function () {
      return import('../views/threeD/LordGanesh.vue')
    }
  },
  {
    path: '/kali-devi',
    name: 'KaliDevi',
    component: function () {
      return import('../views/threeD/KaliDevi.vue')
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: function () {
      return import('../views/Admin.vue')
    },
    beforeEnter(to, from, next) {
      
      let password = localStorage.getItem('password'),
        signInUrl =  'https://login-anantadeva.herokuapp.com/signIn' //'http://localhost:3000/signIn'

      !password ? password = prompt('???') : null
      
      fetch(signInUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password })
      }).then(function (response) {
        return response.json()
      }).then(function (data) {
        
        if (data.auth === 'authorized') {
          localStorage.setItem('password', password)
          console.log(data.auth)
          next()
        } else {
          console.log(data.auth)
          next({
            name: "Home", // back to safety route //
            query: { redirectFrom: to.fullPath }
          })
        }

      })
      // var hasPermission = await store.dispatch("auth/hasPermission");
      // if (hasPermission) {

      // }

    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: function () {
      return import('../views/Blog.vue')
    }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: function () {
      return import('../views/Shop.vue')
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
